import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import { SummaryElement } from './SummaryElement'
import { ExpandCircleDown } from '@mui/icons-material'
import { type SurveyPage } from '../MidYearSummary'

interface Props {
  priorityColor: string
  title: string
  page: SurveyPage
  answers: Record<string, any>
}
export const SurveyPriorityAccordionSummary = (props: Props): JSX.Element => {
  return (
    <Accordion
      data-testid={`accordion-${props.title}`}
      sx={{
        backgroundColor: props.priorityColor,
        color: 'var(--BaseTones-primitive-surface-100, rgba(255, 255, 255, 1))',
        borderRadius: '12px',
        overflow: 'hidden'
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandCircleDown sx={{ color: 'var(--BaseTones-primitive-surface-100, rgba(255, 255, 255, 1))' }} />}
      >
        {props.title}
      </AccordionSummary>
      <AccordionDetails
        sx={{
          backgroundColor: 'white',
          color: 'var(--BaseTones-primitive-nuetral-900, rgba(37, 36, 38, 1))',
          border: `1px solid ${props.priorityColor}`,
          borderRadius: '0 0 12px 12px',
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '24px'
        }}
      >
        <Typography variant='h4'>{props.page.title}</Typography>
        {props.page.elements.map((element) => (
          <SummaryElement key={element.name} element={element} answers={props.answers} />
        ))}
      </AccordionDetails>
    </Accordion>
  )
}
